// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-fundamental-rights-impact-assessment.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-fundamental-rights-impact-assessment',
  title: 'Perform fundamental rights impact assessment for high-risk AI deployments',
  description:
    'Confirm that deployers subject to EU AI Act Art. 27 (public bodies, private operators providing public services, and deployers using high-risk AI for creditworthiness, insurance pricing or law enforcement) conduct a fundamental rights impact assessment (FRIA) prior to first use and after material change of each high-risk AI system. The FRIA shall describe the deployer process, duration and frequency of use, categories of affected natural persons, specific harms to fundamental rights, human-oversight measures and the measures to take if those risks materialise; results shall be notified to the market-surveillance authority. Review the FRIA standard, sample assessments and the notification log.',
  category: 'risk',
  scfIds: ['SCF-AIG-014'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'FRIA procedure is published' },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
